import { gql } from '@apollo/client';

export const REQUEST_IDENTITY_CLAIM = gql`
  mutation RequestIdentityClaim($input: RequestIdentityClaimInput!) {
    requestIdentityClaim(input: $input) {
      requested_email
      kind
    }
  }
`;

export const REQUEST_IDENTITY_CLAIM_INPUT = ['email'];

export const CANCEL_IDENTITY_CLAIM = gql`
  mutation CancelIdentityClaim {
    cancelIdentityClaim
  }
`;

export const CONFIRM_IDENTITY_CLAIM = gql`
  mutation ConfirmIdentityClaim($input: ConfirmIdentityClaimInput!) {
    confirmIdentityClaim(input: $input)
  }
`;

export const CONFIRM_IDENTITY_CLAIM_INPUT = ['password'];

export const MERGE_IDENTITY_CLAIM = gql`
  mutation MergeIdentityClaim($input: MergeIdentityClaimInput!) {
    mergeIdentityClaim(input: $input)
  }
`;

export const MERGE_IDENTITY_CLAIM_INPUT = ['other_access_token'];
